import { string, object } from "yup";

const appvalidate = object().shape({
  companyName: string()
    .required("Company Name required")
    .max(250, "Maximum 150 charcters allowed"),
  tenantCode: string()
    .required("Domain name required")
    .max(150, "Maximum 150 charcters allowed"),
  email: string()
    .required("Business email required")
    .email("Invalid email address")
    .max(150, "Maximum 150 charcters allowed"),
  userName: string()
    .required("Full name required")
    .max(150, "Maximum 150 charcters allowed"),
  password: string()
    .required(" New Password required")
    .matches(
      /^(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}$/,
      "Password should be atleast 8 characters long and should contain one number, one uppercase character and one special character"
    ),
});

export const appvalidateRedemption = object().shape({
  companyName: string()
    .required("Company Name required")
    .max(250, "Maximum 150 charcters allowed"),
  tenantCode: string()
    .required("Domain name required")
    .max(150, "Maximum 150 charcters allowed"),
  email: string()
    .required("Business email required")
    .email("Invalid email address")
    .max(150, "Maximum 150 charcters allowed"),
  userName: string()
    .required("Full name required")
    .max(150, "Maximum 150 charcters allowed"),
  redemption: string()
    .required("Redemption code required")
    .min(8, "Maximum 8 charcters allowed")
    .max(8, "Maximum 8 charcters allowed"),
  password: string()
    .required(" New Password required")
    .matches(
      /^(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}$/,
      "Password should be atleast 8 characters long and should contain one number, one uppercase character and one special character"
    ),
});

export const getAvailability = (err, setFieldError) => {
  if (err === "TD005: Already TenantCode Exist") {
    setFieldError("tenantCode", "Domain name not available");
  } else if (err === "sp") {
    setFieldError("tenantCode", "Special characters not allowed");
  } else if (err === "") {
    setFieldError("tenantCode", "");
  }
};

export const getRedemptionCodeAvailability = (err, setFieldError) => {
  if (err === "InValid code") {
    setFieldError("redemption", "Please enter a valid code");
  } else if (err === "") {
    setFieldError("redemption", "");
  }
};

export const getEmailAvailability = (err, setFieldError) => {
    if (err === "TD005: Already company registerd with this EMAIL ID") {
    setFieldError("email", "Email registered with us already");
  } else if (err === "") {
    setFieldError("email", "");
  }
};
export default appvalidate;
